"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "breda-di-piave": {
    "11af57ba": [{
      "hkey": "7bc521f3",
      "slug": "saletto-san-bartolomeo",
      "name": "Saletto-San Bartolomeo",
      "primary": true,
      "skipSearch": false
    }],
    "saletto": [{
      "hkey": "7bc521f3",
      "slug": "saletto-san-bartolomeo",
      "name": "Saletto-San Bartolomeo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "f9ad5d8e": [{
      "hkey": "7bc521f3",
      "slug": "saletto-san-bartolomeo",
      "name": "Saletto-San Bartolomeo",
      "primary": true,
      "skipSearch": false
    }],
    "san-bartolomeo": [{
      "hkey": "7bc521f3",
      "slug": "saletto-san-bartolomeo",
      "name": "Saletto-San Bartolomeo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "breda-di-piave"
    }]
  }
};
exports["default"] = _default;